import {useParams} from 'react-router-dom';

import {Alert} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {useProviderMapping} from '../hooks/useProviderMapping';
import {DetailPageNavigation} from '../navigation/DetailPageNavigation';
import {ProviderMappingPropertyCard} from '../profile/ProviderMappingPropertyCard';

// Read-only: the module creates and deletes mappings but has no edit path, so the
// detail page carries no tools.
export const DetailPage = () => {
    const {id} = useParams();

    const {record, loading, isError} = useProviderMapping(id);

    if (loading) {
        return <PlatformLoader message={I18n.get('Loading provider mapping...Please wait')}/>;
    }

    // A failed fetch, or an id that resolves to nothing (deleted, mistyped), must not
    // spin the loader forever.
    if (isError || !record) {
        return (
            <Alert color='red' title={I18n.get('Could not load this provider mapping')} m='md'>
                {isError
                    ? I18n.get('The billing API did not return the provider mapping. Try reloading the page.')
                    : `${I18n.get('No provider mapping has the id')} ${id}. ${I18n.get('It may have been deleted.')}`}
            </Alert>
        );
    }

    const title = `${I18n.get(record.entityType)} → ${record.billingProvider?.name ?? record.billingProviderId}`;

    return (
        <FormPageLayout
            title={title}
            pageNavigation={<DetailPageNavigation title={record.providerEntityId || record.id}/>}
        >
            <ProviderMappingPropertyCard record={record}/>
        </FormPageLayout>
    );
};
